import Logo from '../../assets/avatar.png'
import data from './data'
import {IoIosColorPalette} from 'react-icons/io'
import { FaBars } from 'react-icons/fa'
import { AiOutlineClose } from 'react-icons/ai'
import { useState, useEffect } from 'react'
import { useModalContext } from '../../context/modal-context'
import './navbar.css'

const SECTION_IDS = ['header', 'about', 'resume', 'portfolio', 'contact']

const Navbar = () => {
  const [isNavOpen, setIsNavOpen] = useState(false);
  const [activeSection, setActiveSection] = useState('header');
  const { showModalHandler } = useModalContext();

  useEffect(() => {
    const observers = []

    SECTION_IDS.forEach(id => {
      const el = document.getElementById(id)
      if (!el) return

      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) setActiveSection(id)
        },
        { threshold: 0.35 }
      )
      observer.observe(el)
      observers.push(observer)
    })

    return () => observers.forEach(o => o.disconnect())
  }, []);

  const closeNav = () => {
    setIsNavOpen(false);
  };

  const toggleNav = (e) => {
    e.stopPropagation();
    setIsNavOpen(!isNavOpen);
  };

  return (
    <nav>
      <div className="container nav__container">
        {/* Mobile-only burger menu */}
        <button 
          className="nav__toggle-btn" 
          onClick={toggleNav}
        >
          {isNavOpen ? <AiOutlineClose /> : <FaBars />}
        </button>
        
        {/* Logo section - visible on laptop, hidden on mobile */}
        <div className='nav__logo-section'>
          <a href="/" className='nav__logo'>
            <img src={Logo} alt="Logo" />
          </a>
        </div>

        {/* Title - only visible on mobile */}
        <div className="nav__title-mobile">
          <span>Joseph's Portfolio</span>
        </div>

        {/* Main menu - centered on laptop, sliding on mobile */}
        <ul className={`nav__menu ${isNavOpen ? 'nav__menu-open' : ''}`}>
          {
            data.map(item => {
              const sectionId = item.link.replace('#', '') || 'header'
              return (
                <li key={item.id}>
                  <a
                    href={item.link}
                    onClick={closeNav}
                    className={activeSection === sectionId ? 'active' : ''}
                  >
                    {item.title}
                  </a>
                </li>
              )
            })
          }
        </ul>

        {/* Theme toggle - always on right */}
        <button id="theme__icon" onClick={showModalHandler}>
          <IoIosColorPalette />
        </button>

        {/* Mobile menu overlay */}
        <div 
          className={`nav__overlay ${isNavOpen ? 'nav__overlay-visible' : ''}`}
          onClick={closeNav}
        />
      </div>
    </nav>
  )
}

export default Navbar